import React, { FC } from 'react'
import { Box, createStyles, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { LocationPinIcon } from 'transfix-icons'
import { useBrowserLocationContext } from '../context/BrowserLocationContext'

const useStyles = makeStyles(theme =>
  createStyles<string, { variant: string }>({
    root: {
      textAlign: 'left',
      color: ({ variant }) => (variant === 'loadBanner' ? brandColors.white : brandColors.skyBlue7),
      fontWeight: 'bold',
      marginTop: ({ variant }) => (variant === 'loadBanner' ? theme.spacing(-4) : theme.spacing(0)),
      padding: `${theme.spacing(2)} ${theme.spacing(2.5)}`,
    },
  })
)

interface ISetBrowserLocationBarProps {
  /**
   * On bar click
   */
  onClick: () => void
  variant: 'loadBanner' | 'loadSearch'
}

/**
 * Bar currently used for Mobile View only on `/fms/book`
 */
export const SetBrowserLocationBar: FC<ISetBrowserLocationBarProps> = React.memo(
  ({ onClick, variant }) => {
    const classes = useStyles({ variant })
    const { browserLocation, hasLocationName } = useBrowserLocationContext()
    const { cityName, stateCode } = browserLocation || {}
    const pinColor = variant === 'loadBanner' ? 'white' : 'skyBlue6'

    return (
      <Box data-test='set-browser-location-bar' className={classes.root} onClick={onClick}>
        <Box display='flex' flexDirection='row' alignItems='center'>
          <LocationPinIcon size='large' color={pinColor} />
          <Box pl={1}>
            <Typography variant='caption'>
              My location - {hasLocationName ? `${cityName}, ${stateCode}` : 'Set Location'}
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  }
)
